module.exports = __webpack_public_path__ + "media/images/new-ui-images/lab-icon-73b398aa6fd728bede4141bf4ccd39cc.svg";